import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import "../../css/Admin-Education/UploadEducation.css";
import Spinner from "../Spinner";

const UploadEducation = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [uploadEducationLogo, setUploadEducationLogo] = useState(0);
  const [uploadEducationCertificates, setUploadEducationCertificates] = useState(0);
  const [data, setData] = useState({
    educationName: "",
    educationInstitute: "",
    educationYear: "",
    educationLogo: [],
    educationCertificates: [],
  });
  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.educationName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setUploadEducationLogo(progress);
          console.log("Upload is " + progress + "% done");
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              educationLogo: [...(prev.educationLogo || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCertificates(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.educationName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Image Upload is " + progress + "% done");
          setUploadEducationCertificates(progress)
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              educationCertificates: [...(prev.educationCertificates || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteLogo = (index) => {
    const newLogos = [...data.educationLogo];
    newLogos.splice(index, 1);
    setData((pre) => ({
      ...pre,
      educationLogo: newLogos,
    }));
  };

  const handleDeleteCertificates= (index) => {
    const newCertificates= [...data.educationCertificates];
    newCertificates.splice(index, 1);
    setData((pre) => ({
      ...pre,
      educationCertificates: newCertificates,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db, "educations"), data);
    setLoading(false);
    toast.success("Education Added");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Add Education</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="educationName">Education Name :</label>
          <input
            type="text"
            id="educationName"
            placeholder="Enter Education name"
            value={data.educationName}
            name="educationName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="educationInstitute">Institute Name :</label>
          <input
            type="text"
            id="educationInstitute"
            placeholder="Enter Institute Name"
            value={data.educationInstitute}
            name="educationInstitute"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="educationYear">
            Year :
          </label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Year"
            value={data.educationYear}
            name="educationYear"
            onChange={handleOnChange}
          />

          <label htmlFor="educationLogo" className="label">
            Education Logo :
          </label>
          <label htmlFor="educationLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Education Logo</p>
                <input
                  type="file"
                  id="educationLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadEducationLogo > 0 && uploadEducationLogo < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadEducationLogo}% done`}</label>
          )}

          <div>
            {data.educationLogo.length > 0 ? (
              <div className="image-preview">
                {data.educationLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Education Logo</p>
            )}
          </div>

          <label htmlFor="educationCertificates" className="label">
            Certificates:
          </label>
          <label htmlFor="educationCertificates">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Education Certificates</p>
                <input
                  type="file"
                  id="educationCertificates"
                  className="hidden"
                  onChange={handleUploadCertificates}
                />
              </div>
            </div>
          </label>
          {uploadEducationCertificates > 0 && uploadEducationCertificates < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadEducationCertificates}% done`}</label>
          )}

          <div>
            {data.educationCertificates.length > 0 ? (
              <div className="image-preview">
                {data.educationCertificates.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteCertificates(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Education Certificates</p>
            )}
          </div>
          
          <button className="submit-button" disabled={loading}>
            Add Education
          </button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default UploadEducation;
